import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { EUserRoles } from '../../models/user.model';
import { useUser } from '../../hooks/user';
import { Box, Typography } from '@mui/material';

type Props = {
  children: React.ReactNode;
  roles?: EUserRoles[];
};

export default function AuthOnly({ children, roles }: Props) {
  const auth = useAuth();
  const user = useUser();
  if (!auth.isAuth) {
    return (
      <Navigate
        to={{
          pathname: '/sign-in',
        }}
      />
    );
  }

  if (roles?.length && user?.role && !roles.includes(user.role)) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h4">Access is denied</Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
